<div><ng-content></ng-content></div>
@if (comingSoon()) {
  <app-badge color="orange" icon="/assets/icons/16/clock-filled.svg">Soon</app-badge>
}
